export class ResourceGraph {
    get(uri) {
        return this[uri] || this[decodeURI(uri)];
    }
    add(resource) {
        this[resource.id] = resource;
    }
}
//# sourceMappingURL=ResourceGraph.js.map